/* The provider owns submissions; this element only manages its iframe presentation. */
if (!customElements.get('maison-affiliate-form')) {
  customElements.define('maison-affiliate-form', class extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('[data-affiliate-frame]');
      this.status = this.querySelector('[data-form-status]');
      if (!this.frame || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const loaded = () => {
        window.clearTimeout(this.loadingTimer);
        if (this.status) this.status.hidden = true;
      };
      this.frame.addEventListener('load', loaded, options);
      window.addEventListener('message', (event) => {
        if (event.origin !== 'https://forms.influencer-hero.com' || event.source !== this.frame.contentWindow) return;
        const data = event.data;
        if (!data || typeof data !== 'object') return;
        const rawHeight = data.iframeHeight ?? (data.type === 'SET_HEIGHT' ? data.height : null);
        if (typeof rawHeight !== 'number' && typeof rawHeight !== 'string') return;
        const height = Number(rawHeight);
        if (!Number.isFinite(height) || height < 200 || height > 20000) return;
        this.frame.style.setProperty('--maison-affiliate-form-measured-height', `${Math.ceil(height)}px`);
        loaded();
      }, options);
      this.loadingTimer = window.setTimeout(() => {
        if (this.status) this.status.textContent = this.dataset.slowLabel || 'Open the application form using the link below.';
      }, 15000);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      window.clearTimeout(this.loadingTimer);
    }
  });
}
